import React, {useContext} from 'react';
import {TextField} from "@mui/material";
import {getHelperStyle} from "../../../styles/components/FormStyle";
import InputAdornment from "@mui/material/InputAdornment";
import {languages} from "../../../strings/LanguageDictionary";
import {AppContext} from "../../../App";


const CustomTextWithAdornement = ({
	                                  inputRef, name, label, autoFocus, autoComplete, type, inputProps, error, disabled,
	                                  adornement, handleKeyPress, handleKeyDown, multiline = false, rows = 1, className = ""
                                  }) => {
	const appContext = useContext(AppContext)
	
	return (
		<React.Fragment>
			<TextField
				className={className}
				onKeyPress={(event) => handleKeyPress(event)}
				onKeyDown={(event) => handleKeyDown(event)}
				disabled={disabled}
				inputRef={inputRef}
				name={name}
				id={name}
				label={label}
				autoFocus={autoFocus}
				autoComplete={autoComplete}
				type={type}
				multiline={multiline}
				rows={rows}
				fullWidth={true}
				variant={"outlined"}
				inputProps={inputProps}
				error={error !== undefined}
				helperText={error?.type === "validate" ? languages[appContext.state.lang].OCEAN__GLOBAL_NOT_VALID_FILES : error?.message ? languages[appContext.state.lang].OCEAN__GLOBAL_REQUIRED_FILES_ : ""}
				FormHelperTextProps={{
					style: getHelperStyle().helper
				}}
				InputProps={{
					endAdornment: <InputAdornment position="end">{adornement}</InputAdornment>
				}}
			/>
		</React.Fragment>
	);
}

export default React.memo(CustomTextWithAdornement)
